module.exports = __webpack_public_path__ + "img/icon_input_skype.db88f1f.svg";